import { IFilterOptions } from '../../../../components/FilterCard/filterCard';
export interface Attendance {
  totalCount: number
  totalEmployees: number
  totalPresent: number
  totalAbsent: number
  records: AttendanceRecord[]
}
export interface AttendanceRecord {
  id: number;
  employeeId: number;
  employeeName: string;
  startTime: string | null;
  endTime: string | null;
  date: string;
  status: number;
  employee_Code: string;
  isLate?: boolean;
  totalBreakTime?: string;
  breakDetails?: any[];
  status_Name: string;
  payroll_Attendance_Status:number;
  source?: string;
}

export const getSourceBadgeClass = (source?: string) => {
  switch ((source || '').toLowerCase()) {
    case 'regularization':
      return 'status_badge purple';
    case 'manual':
      return 'status_badge orange';
    case 'remote':
      return 'status_badge cyan';
    case 'automatic':
    default:
      return 'status_badge green';
  }
};

export const getStatusClass = (status: number) => {
  switch (status) {
    case 1:
      return 'status_badge green';       // Present
    case 0:
      return 'status_badge red';         // Absent
    case 2:
      return 'status_badge orange';      // Half Day
    case 3:
      return 'status_badge yellow';      // Late
    case 4:
      return 'status_badge purple';      // Early Out
    case 5:
      return 'status_badge blue';        // Punch In Missing
    case 6:
      return 'status_badge pink';        // Punch Out Missing
    case 7:
      return 'status_badge cyan';        // Week Off
    case 8:
      return 'status_badge green';       // Holiday
    case 9:
      return 'status_badge teal';        // Short Leave
    case 10:
      return 'status_badge amber';       // SL-Half Day
    default:
      return 'status_badge gray';
  }
};

export const getPayrollStatusClass = (status: number) => {
  switch (status) {
    case 1:
      return 'status_badge green';       // Present
    case 0:
      return 'status_badge red';         // Absent
    case 2:
      return 'status_badge orange';      // Half Day
    case 3:
      return 'status_badge cyan';        // Week Off
    case 4:
      return 'status_badge green';       // Holiday
    default:
      return 'status_badge gray';
  }
};

export const getPayrollStatusName = (status: number) => {
  switch (status) {
    case 1:
      return 'Present';
    case 0:
      return 'Absent';
    case 2:
      return 'Half Day';
    case 3:
      return 'Week Off';
    case 4:
      return 'Holiday';
    default:
      return 'Unknown';
  }
};

export const sortOptions = [
  'Check-In Time (Earliest to Latest)',
  'Check-In Time (Latest to Earliest)',
  'Check-Out Time (Earliest to Latest)',
  'Check-Out Time (Latest to Earliest)',
  'Name (A–Z)',
  'Name (Z–A)',
];

export const sortMapping: Record<string, { field: keyof AttendanceRecord; order: 1 | -1 }> = {
  'Name (A–Z)': { field: 'employeeName', order: 1 },
  'Name (Z–A)': { field: 'employeeName', order: -1 },
  'Check-In Time (Earliest to Latest)': { field: 'startTime', order: 1 },
  'Check-In Time (Latest to Earliest)': { field: 'startTime', order: -1 },
  'Check-Out Time (Earliest to Latest)': { field: 'endTime', order: 1 },
  'Check-Out Time (Latest to Earliest)': { field: 'endTime', order: -1 },
};

export interface Props {

  attendanceData: Attendance;
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  lazyParams: {
    first: number;
    rows: number;
    page: number;
    sortField: string;
    sortOrder: number;
  };
  setAttendanceFilter: React.Dispatch<any>;

  setLazyParams: React.Dispatch<React.SetStateAction<any>>;
  totalCount: number;
  pageCount: number;
  handlePageClick: ({ selected }: { selected: number }) => void;
  loading: boolean;
  setRowsPerPage: (rows: number) => void;
  filter: IFilterOptions;
  setSelectedItems: React.Dispatch<React.SetStateAction<Record<string, number[]>>>
  setFilterApplied: any;
}

// export const headers = [
//   { id: 1, name: "S. No" },
//   { id: 2, name: "Emp. ID" },
//   { id: 3, name: "Name" },
//   { id: 4, name: "Check In" },
//   { id: 5, name: "Check Out" },
//   { id: 6, name: "Date" },
//   { id: 7, name: "Status" },
// ];